import { useEffect, useState } from "react";

/** @returns Origin of the Procore web app the scene belongs to: the dev proxy's target under the dev server. */
export function useProcoreOrigin() {
    const devProxyTarget = useDevProxyTarget();
    return import.meta.env.DEV ? devProxyTarget : window.location.origin;
}

/** @returns The dev server's `PROCORE_API_PROXY_TARGET`, read at runtime since the debug page can switch it. */
function useDevProxyTarget() {
    const [target, setTarget] = useState<string>();

    useEffect(() => {
        if (!import.meta.env.DEV) {
            return;
        }
        let cancelled = false;
        fetch("/__debug/procore-proxy-target")
            .then((res) => res.json() as Promise<{ target: string }>)
            .then(
                ({ target }) => !cancelled && setTarget(target || undefined),
                (e: unknown) => console.error("Failed to read Procore proxy target", e),
            );
        return () => {
            cancelled = true;
        };
    }, []);

    return target;
}
